export default {
    TOKENS_CONFIRMATION: "TOKENS_CONFIRMATION",
    ACCESS_EDIT: "ACCESS_EDIT",
    SETTINGS_EDIT: "SETTINGS_EDIT",
    DASHBOARD_REFRESH: "DASHBOARD_REFRESH",
};
